function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
const useStyles = makeStyles(theme => ({
  root: {
    "&[data-status=trash]": {
      "& figure": {
        opacity: "0.5"
      }
    },
    "&.sortable-helper": {
      boxShadow: theme.shadows[12],
      zIndex: 2000
    }
  }
}));

const ModuleBase = (_ref) => {
  let id = _ref.id,
      name = _ref.name,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? "article" : _ref$component,
      className = _ref.className,
      size = _ref.size,
      status = _ref.status,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? false : _ref$collapsible,
      _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? false : _ref$expanded,
      toolbar = _ref.toolbar,
      settings = _ref.settings,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      onClick = _ref.onClick,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "name", "component", "className", "size", "status", "selectable", "selected", "collapsible", "expanded", "toolbar", "settings", "elevation", "onClick", "children"]);

  const classes = useStyles();

  if (component === "tr") {
    return React.createElement("tr", {
      id: id,
      className: className || classes.root,
      "data-grid-cols": props.gridCols,
      "data-id": id,
      "data-name": name,
      "data-size": size,
      "data-status": status,
      "aria-expanded": expanded,
      "aria-selected": selected,
      role: onClick && "button",
      onClick: onClick
    }, children);
  }

  if (!elevation) {
    return React.createElement("article", {
      id: id,
      className: className || classes.root,
      "data-grid-cols": props.gridCols,
      "data-id": id,
      "data-name": name,
      "data-size": size,
      "data-status": status,
      "aria-expanded": expanded,
      "aria-selected": selected,
      role: onClick && "button",
      onClick: onClick
    }, children);
  }

  return React.createElement(Paper, {
    id: id,
    component: component,
    className: className || classes.root,
    "data-grid-cols": props.gridCols,
    "data-id": id,
    "data-name": name,
    "data-size": size,
    "data-status": status,
    "aria-expanded": expanded,
    "aria-selected": selected,
    "data-elevated": true,
    elevation: elevation,
    square: true,
    role: onClick && "button",
    onClick: onClick
  }, children);
};

ModuleBase.propTypes = process.env.NODE_ENV !== "production" ? {
  id: PropTypes.any,
  elevation: PropTypes.number,
  draggable: PropTypes.bool,
  draggableHandle: PropTypes.bool,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  collapsible: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
  deletable: PropTypes.bool,
  restorable: PropTypes.bool,
  onDelete: PropTypes.func,
  onRestore: PropTypes.func,
  onErase: PropTypes.func,
  draggable: PropTypes.bool,
  hideable: PropTypes.bool,
  hidden: PropTypes.bool
} : {};
export default ModuleBase;